export default 'M12 0L1 10v14h8v-7a3 3 0 116 0v7h8V10z';